<template>
    <div>
      <el-upload
        action="#"
        :class="{ hide: hideUpload }"
        :on-change="onChange"
        v-loading="loading"
        :element-loading-text="loadingText"
        :limit="limit"
        :http-request="uploadAction"
        :on-exceed="onExceed"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-remove="handleRemove"
        :disabled="isDisabled"
        :file-list="fileList"
        :auto-upload="true"
        :multiple="limit > 1 ? true : false"
        accept=".jpg,.png,.gif,.jpg,.bmp,.jpeg"
        ref="uploadRef"
      >
        <template #tip>
          <div v-if="isTip" class="el-upload__tip" style="color: #b1aeae">
            <p>1. 图片格式要求：只能上传.jpg,.png,.gif,.bmp,.jpeg 的图片文件</p>
            <p style="position: relative;bottom: 1rem;">2. 图片文件大小：不能超过5120kb</p>
            <div>{{ isThreeTip ? "3. " + isThreeTip : "" }}</div>
          </div>
          <span
            v-if="isYes"
            class="dialog-footer btn-area"
            style="margin-top: 20px; display: flex; justify-content: flex-end"
          >
            <el-button type="primary" @click="onSubmit1()">确定</el-button>
          </span>
        </template>
        <template #default>
          <el-icon>
            <Plus />
          </el-icon>
        </template>
      </el-upload>
      <!-- 预览 -->
      <el-dialog v-model="dialogVisible" append-to-body top="10vh">
        <img style="width: 100%" :src="dialogImageUrl" alt="Preview Image" />
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { ImgUpload, DeleteImages } from "network/upload";
  import { toRefs, reactive, ref, onMounted, toRaw, watch } from "vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  export default {
    name: "ImageUpload",
    props: {
      // type = 1 文章内容图片
      // type = 2 文章封面图片/轮播图（幻灯片）/学员访谈图片/PC端广告图
      // type = 3 普本、成教、网教院校logo
      type: Number,
      //接收父组件参数
      imagePath: {
        //用于初始化图片上传组件的图片文件路径：""为未上传时(即添加时使用),否则请赋值用户所上传图片的路径(组件将自动初始化)
        type: String || Array,
        default: "",
      },
      // 是否要确认按钮
      isYes: {
        type: Boolean,
        default: false,
      },
  
      //图片上传数量限制
      limit: {
        type: Number,
        default: 1,
      },
      // 第三条备注
      isThreeTip: {
        type: String,
        default: "",
      },
      // 是否要备注
      isTip: {
        type: Boolean,
        default: true,
      },
      // 是否禁用
      isDisabled: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { emit }) {
      const data = reactive({
        loading: false, //加载状态开关
        loadingText: "loading...", //加载状态提示文本
        fileList: [], //图片展示列表
        disabled: false,
        dialogVisible: false, //图片预览
        dialogImageUrl: "", //图片预览url
        hideUpload: false, //是否展示上传入口
        initImagePath: null, //初始化（编辑时）
        oldImglist: [], //旧图片数组  编辑时
        newImglist: [], //新上传图片数组
      });
  
      watch(
        () => data.fileList,
        (newVal, oldVal) => {
          data.hideUpload = newVal.length >= props.limit ? true : false;
        }
      );
      onMounted(() => {
        if (props.imagePath) {
          let isArr = Array.isArray(props.imagePath); //是数组还是字符串
          //initImagePath用于初始化，重新赋值避免修改图片传给父组件，父组件又传回的问题
          data.initImagePath = JSON.parse(JSON.stringify(props.imagePath));
          if (isArr) {
            //多张图
            data.initImagePath.map((item) => {
              data.fileList.push({
                name: "默认已选图片",
                url: item || item.url,
              });
            });
            data.oldImglist = JSON.parse(JSON.stringify(data.fileList));
          } else {
            //单张图
            data.fileList = [];
            data.fileList.push({
              name: "初始化图片",
              url: data.initImagePath,
            });
            data.oldImglist = JSON.parse(JSON.stringify(data.fileList)); //旧图片数组
          }
        }
      });
      const uploadRef = ref(null);
      // 自定义上传行为,覆盖默认action
      const uploadAction = async (f) => {
        const files = f.file;
        //文件上传提示中限制了大小,前端再调取接口前也限制一下
        let howM = files.size / (1024 * 1024);
        if (howM > 5) {
          ElMessage.error("图片大小不能超过5M");
          abort();
        }
        let fd = new FormData();
        fd.append("file", files);
        data.loading = true;
        data.loadingText = "上传中...";
        await ImgUpload(fd)
          .then((res) => {
            data.loading = false;
  
            if (res && res.code == 1) {
              f.onSuccess(f);
              // 存全部新上传记录
              data.newImglist.push({
                name: f.file.name,
                url: res.result.fileData.src,
              });
  
              // 上传数量限制
              if (props.limit == 1) {
                data.fileList = [{ name: f.file.name, url: res.result.fileData.src }];
              } else {
                data.fileList.push({
                  name: f.file.name,
                  url: res.result.fileData.src,
                });
              }
              data.hideUpload =
                data.fileList.length >= props.limit ? true : false;
              // console.log(data.newImglist, "全部新上传");
              // console.log(data.fileList, "展示");
              eventTrigger(); //传给父组件
            } else {
              data.fileList = [];
              clearFiles();
              ElMessageBox.alert(res.message, "提示", {
                confirmButtonText: "确认",
              });
            }
          })
          .catch((err) => {
            // 接口报错但是file已经存在，这里删除下
            if (props.limit == 1) {
              data.fileList = [];
            } else {
              for (let i = 0; i < data.fileList.length; i++) {
                if (data.fileList[i].name == f.file.name) {
                  data.fileList.splice(i, 1);
                }
              }
              data.hideUpload =
                data.fileList.length >= props.limit ? true : false;
            }
          });
      };
      // 向父组件发送数据
      function eventTrigger() {
        emit("change-image", data.fileList);
      }
  
      // 查看
      const handlePictureCardPreview = (file) => {
        data.dialogImageUrl = file.url;
        data.dialogVisible = true;
      };
    //父组件提交数据的时候 删除无用图片操作
      //  逻辑：提交给接口的数据和旧图片+新上传的全部记录对比，排除提交给接口的，其他的都是无用的图，删除
      const submitData = (paths) => {
        //paths接收数据格式['','']，不要字段，直接数组字符串
        // 旧图片数组和新图片数组合并
        let aLLFilePaths = data.oldImglist.concat(data.newImglist);
        // console.log(aLLFilePaths, "旧图片数组和新图片数组合并");
        // 数组
        if (Array.isArray(paths)) {
          let deleteFilePath = differenceBy(paths, aLLFilePaths, "url");
          // console.log(deleteFilePath, "数组，要删除的图");
          deleteFileFnc(deleteFilePath);
        } else {
          // 字符串(提交表单有这个图，我们不删除这个图，把他排除出来，其他没用的图调删除接口)
          if (aLLFilePaths && aLLFilePaths.length > 0) {
            for (var i = 0; i < aLLFilePaths.length; i++) {
              if (aLLFilePaths[i].url == paths) {
                aLLFilePaths.splice(i, 1);
              }
            }
            // console.log(aLLFilePaths, "字符串，要删除的图");
            deleteFileFnc(aLLFilePaths);
          }
        }
      };
      // 比较两个数组对象，取不同值
      const differenceBy = (array1, array2, key) => {
        var result = [];
        for (var i = 0; i < array2.length; i++) {
          var obj = array2[i];
          var path = obj[key];
          var isExist = false;
          if (path && path !== 0) {
            for (var j = 0; j < array1.length; j++) {
              var url = array1[j];
              if (url === path) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
        }
        return result;
      };
      // 删除
      const handleRemove = (file, fileList) => {
        const result = new Promise((resolve, reject) => {
          ElMessageBox.confirm("删除之后不能恢复,确定要删除吗?", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              ElMessage.success("删除成功！");
              let index = fileList.indexOf(file);
              if (index != -1) {
                fileList.splice(index, 1);
                data.fileList = fileList;
                data.hideUpload =
                  data.fileList.length >= props.limit;
                eventTrigger();
              } else {
                ElMessage.error("删除图片失败");
              }
            })
            .catch(() => {
              reject(false);
            });
        });
        return result;
      };
      //关闭 取消弹窗的时候 删除全部新上传记录
      const cancelData = () => {
        deleteFileFnc(data.newImglist);
        data.fileList = [];
      };
      // 删除图片请求
      function deleteFileFnc(files) {
        let paths = [];
        if (files && files.length > 0) {
          files.map((item) => {
            paths.push(item.url);
          });
        }
        if(paths.length != 0){
          DeleteImages(paths)
          .then((res) => {
            if (res.code == 0) {
              ElMessage.error(res.message);
              return false;
            }
            data.newImglist = [];
          })
          .catch((err) => {
            ElMessage.error(err);
          });
        }
      }
      // 清空已上传的文件列表
      const clearFiles = () => {
        if (uploadRef.value) uploadRef.value.clearFiles();
      };
      const onExceed = () => {
        //当图片数量小于限制
        if (data.fileList.length < props.limit) {
          let number = data.fileList.length - props.limit;
          ElMessage.warning(
            `最多只能上传${props.limit}张,当前还可以上传${number}张`
          );
        }
      };
      return {
        ...toRefs(data),
        uploadRef,
        uploadAction,
        handleRemove,
        handlePictureCardPreview,
        submitData,
        cancelData,
        clearFiles,
        onExceed,
      };
    },
  };
  </script>
  <style scoped>
  .el-dialog__wrapper >>> .el-dialog {
    background-color: rgba(255, 255, 255, 0.1);
    margin-top: 12vh !important;
    position: static;
  }
  
  .el-dialog__wrapper >>> .el-icon-close {
    color: #f2f2f2;
    font-size: 26px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #666;
    text-align: center;
    line-height: 40px;
  }
  
  .el-dialog__wrapper >>> .el-dialog__headerbtn {
    top: 50px;
  }
  
  /deep/.el-icon-close-tip {
    display: none !important;
  }
  
  /deep/.is-ready {
    display: none;
  }
  
  .btn-area button {
    margin-top: 20px;
  }
  
  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100% !important;
    height: 100% !important;
    object-fit: fill !important;
  }
  
  .imgstyle {
    width: 100%;
  }
  </style>
  <style>
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .hide,
  .none {
    display: inline-block;
  }
  </style>
  